{
  "title": "Galder's Tower",
  "source": "Lost Laboratory of Kwalish",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "10 minutes",
  "range": "30 feet",
  "components": "V, S, M (a fragment of stone, wood, or other building material)",
  "duration": "24 hours",
  "description": [
    "You conjure a two-story tower made of stone, wood, or similar suitably sturdy materials. The tower can be round or square in shape. Each level of the tower is 10 feet tall and has an area of up to 100 square feet. Access between levels consists of a simple ladder and hatch. Each level takes one of the following forms, chosen by you when you cast the spell:",
    "A bedroom with a bed, chairs, chest, and magical fireplace",
    "A study with desks, books, bookshelves, parchments, ink, and ink pens",
    "A dining space with a table, chairs, magical fireplace, containers, and cooking utensils",
    "A lounge with couches, armchairs, side tables and footstools",
    "A washroom with toilets, washtubs, a magical brazier, and sauna benches",
    "An observatory with a telescope and maps of the night sky",
    "An unfurnished, empty room",
    "The interior of the tower is warm and dry, regardless of conditions outside. Any equipment or furnishings conjured with the tower dissipate into smoke if removed from it. At the end of the spell’s duration, all creatures and objects within the tower that were not created by the spell appear safely outside on the ground, and all traces of the tower and its furnishings disappear.",
    "You can cast this spell again while it is active to maintain the tower’s existence for another 24 hours. You can create a permanent tower by casting this spell in the same location and with the same configuration every day for one year.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the tower can have one additional story for each slot level beyond 3rd."
  ],
  "spellLists": ["wizard"]
}
